// extracted by mini-css-extract-plugin
export default {"content":"error-page_content__ZMatn"};